export enum AnnounceType {
  Assertive = 'assertive',
  Polite = 'polite'
}

export type AnnounceFunc = (
  message: string,
  announceType?: AnnounceType
) => void;

export interface IAnnouncerContextProps {
  announce: AnnounceFunc;
}

export interface IAnnouncerProps {}

export interface IAnnouncerState {
  message?: string;
  announceType?: AnnounceType;
}

export type IAnnounceMessageProps = IAnnouncerState;
